export default __webpack_public_path__ + "static/cover-how-to-hire-ux-designer-c6f2e1e46241766aff21024ad665f808.png";